/**
 * ObjectTimeField React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// icons
import ScheduleIcon from '@material-ui/icons/Schedule';

// 3rd party components
import {TimePicker} from 'material-ui-pickers';

// application
import {toLocalISOTimeString, toTimeOnlyDate} from '../../utils';


/**
 * ObjectDateField is an editing component for time fields of objects
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectTimeField extends React.Component {

    render() {

        return <TimePicker
            keyboard
            label={this.props.fieldDef.name}
            format="HH:mm"
            mask={[/\d/, /\d/, ':', /\d/, /\d/]}
            ampm={false}
            value={this.props.value ? toTimeOnlyDate(this.props.value) : null}
            disabled={this.props.readOnly}
            clearable={true}
            onChange={value => this.props.onObjectValueChange(
                this.props.fieldDef.id, value != null ? toLocalISOTimeString(value, false) : undefined
            )}
            disableOpenOnEnter
            fullWidth={true}
            margin="normal"
            keyboardIcon={<ScheduleIcon/>}
            invalidDateMessage="ungültiges Zeitformat"
        />;
    }
}

ObjectTimeField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

export default ObjectTimeField;